export class LearningContentRatingDto {
    text: string;
    numRatings = 0;
    ratingAvg = 0;
}
